import React, {useState, useEffect} from "react";
import {ListFacilitatorsService, FacilitatorProfile} from "../services/FacilitatorsService";

export const FacilitatorsContext = React.createContext();

export default function FacilitatorsProvider({children}) {
   const [completeList, setList] = useState([]);
   const [wineList, setWine] = useState([]);
   const [barList, setBar] = useState([]);
   const [visibleList, setVisibles] = useState([]);
   const [isLoading, setLoading] = useState({visibles: true});
   const [currentFacilitator, setFacilitator] = useState({isLoading: true});

   /*   useEffect(() => {
      getVisibles();
   }, [completeList]); */

   useEffect(() => {
      getWineList();
      getBarList();
   }, [completeList]);

   const getFacilitators = (force = false) => {
      ListFacilitatorsService()
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            let newList = data.map((item) => {
               return {...item, name: item.facilitatorName + " " + item.facilitatorLastName};
            });
            setList([...newList]);
         })
         .catch((e) => {
            console.log(e);
         });
   };

   function getWineList() {
      const listWine = completeList.filter((item) => item.idFacilitatorArea === 1);
      setWine(listWine);
      setLoading({...isLoading, wine: false, bar: false});
   }
 
   function getBarList() {
      const listBar = completeList.filter((item) => item.idFacilitatorArea === 2);
      setBar(listBar);
      setLoading({...isLoading, bar: false, wine: false});
   }

   /*  function getVisibles() {
      const listVisible = completeList.filter((item) => item.isActive);
      setVisibles(listVisible);
      setLoading({...isLoading, visibles: false});
   }
 */
   function getOnlyOne(id) {
      const newFa = completeList.find((item) => item.idFacilitator === id);
      if (!newFa) {
         FacilitatorProfile(id)
            .then((res) => res.json())
            .then((resp) => {
               const {status, data} = resp;
               if (status === "error") throw new Error();
               setFacilitator({isLoading: false, ...data[0]});
            })
            .catch((e) => {
               console.log(e);
            });
      } else {
         setFacilitator(newFa);
      }
   }

   return (
      <FacilitatorsContext.Provider value={{getFacilitators, wineList, barList, isLoading, getOnlyOne, currentFacilitator}}>
         {children}
      </FacilitatorsContext.Provider>
   );
}
